import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import Backend from 'i18next-http-backend'
import LocizeBackend from 'i18next-locize-backend'
import LanguageDetector from 'i18next-browser-languagedetector'
import moment from 'moment'

import de  from 'date-fns/locale/de'
import { registerLocale } from  "react-datepicker"
registerLocale('de', de)


//standard options used for both backend configurations
const i18nOptions = {
  fallbackLng: 'en',
  debug: false,
  interpolation: {
    escapeValue: false
  },
  detection: {
    order: ['localStorage', 'navigator'],
    caches: ['localStorage']
  }/*,
  react: {
    wait: true,
    useSuspense: false
 }*/
}

if (process.env.REACT_APP_I18N_BACKEND === 'local') {
  //serve the language files from /public/locales
  i18n
    .use(LanguageDetector)
    .use(Backend)
    .use(initReactI18next)
    .init({
      ...i18nOptions
    })
} else {
  //serve the language files from the locize hosted service
  i18n
    .use(LanguageDetector)
    .use(LocizeBackend)
    .use(initReactI18next)
    .init({
      ...i18nOptions,
      saveMissing: true,
      backend: {
        projectId: '30157f11-a6df-4983-b64c-f02688d5ee2d',
        apiKey: process.env.REACT_APP_LOCIZE_API_KEY,
        version: process.env.REACT_APP_LOCIZE_VERSION ? process.env.REACT_APP_LOCIZE_VERSION : 'latest',
        referenceLng: 'en'
      }
    })
}

//This means we can use moment anywhere and it will be the right locale
//Note that any locales (other than en) that we want to support must be imported in index.tsx
i18n.on('languageChanged', function(lng) {
  moment.locale(lng)
})

export default i18n
